import { Negotiation } from '@/modules/negotiation/entities/interfaces/negotiation';
import { get } from 'lodash';

const { REACT_APP_PROVIDER_BY_ID = '{}' } = process.env;

const providerById = JSON.parse(REACT_APP_PROVIDER_BY_ID);

export const isBradesco = (negotiation: Negotiation) => {
  const providerId = get(negotiation, 'product.providerId');
  return providerById[providerId] === 'bradesco';
};
